module.exports = __webpack_public_path__ + "static/media/7.bf646f3f.jpg";